<template>
  <v-layout row justify-center display: flex style="margin-top: 65px;">
        <v-navigation-drawer
      width="620"
      v-model="transactionmodal"
      fixed
      right
      clipped
    >
          <v-btn flat small class="green-darken-text" @click="transactionmodal = false"><v-icon>close</v-icon>CLOSE</v-btn>
          <p class="font-size-20-bold" align="center" style="margin-bottom:0px;" >Invoices</p><br>

          <v-layout px-4>

          </v-layout>
        <v-layout align-center justify-center row wrap>
          <v-flex xs11 px-1>
            <v-data-table
              class="elevation-3"
              :headers="headers"
              :items="transview"
              item-key="invoice_no"
              hide-actions
              id="tableDetail"
            >
              <template v-slot:items="props" class="tmodal_data">
                <tr style="cursor: pointer;">
                  <td data-label="No." class="text-xs-center" >{{ props.index + 1}}</td>
                  <td data-label="Invoice No" class="text-xs-left"><span class="green-darken-text"><strong>{{ props.item.invoice_no }}</strong></span></td>
                  <td data-label="Start Date" class="text-xs-left">{{ props.item.sv_period_start_date }}</td>
                  <td data-label="End Date" class="text-xs-left">{{ props.item.sv_period_end_date }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
        <v-flex pb-5></v-flex>
    </v-navigation-drawer>
  </v-layout>
</template>

<script>
import { sync } from 'vuex-pathify'
import moment from 'moment'
moment.locale('en')
export default {
  data () {
    return {
      mobileView: false,
      dialogloader: false,
      notifications: false,
      time_sub: '',
      sound: true,
      widgets: false,
      transactiondata: [],
      invoicedata: [],
      tempinvoices: [],
      headers: [
        { text: 'No.', value: 'index', sortable: false, align: 'center' },
        {
          text: 'Invoice No.',
          value: 'invoice_no',
          align: 'left'
        },
        {
          text: 'Start Date',
          value: 'Start_date',
          align: 'left'
        },
        {
          text: 'End Date',
          value: 'Start_date',
          align: 'left'
        }
      ]
    }
  },
  methods: {
    async gettransactiondata () {
      if (this.currenttransaction) {
        try {
          this.istableloading = true
          let { data } = await this.axios.post(`${process.env.VUE_APP_APIHOST}/detail_transaction/`,
            {
              trans_id: this.currenttransaction
            })
          this.transactiondata = data
          this.istableloading = false
        } catch (error) {
          this.istableloading = false
          console.log(error.message)
        }
      }
    },
    addCommas (nStr) {
      nStr += ''
      var x = nStr.split('.')
      var x1 = x[0]
      var x2 = x.length > 1 ? '.' + x[1] : ''
      var rgx = /(\d+)(\d{3})/
      while (rgx.test(x1)) {
        x1 = x1.replace(rgx, '$1' + ',' + '$2')
      }
      return x1 + x2
    },
    handleView () {
      this.mobileView = window.innerWidth <= 990
      this.$cookies.set('screenView', this.mobileView)
    }
  },
  computed: {
    transactionmodal: sync('transactionmodal'),
    currenttransaction: sync('currenttransaction'),
    invoiceoftransaction: sync('invoiceoftransaction'),
    transview () {
      return this.transactiondata.map(inv => {
        return {
          ...inv,
          sv_period_end_date: moment(inv.sv_period_end_date).format('DD MMMM YYYY'),
          sv_period_start_date: moment(inv.sv_period_start_date).format('DD MMMM YYYY')
        }
      })
    }
  },
  watch: {
    currenttransaction () {
      this.gettransactiondata()
    }
  },
  created () {
    this.gettransactiondata()
    this.handleView()
  }
}
</script>
<style>
</style>
